<app-summary-page [order]="order$ | async"
                  [addresses]="addresses$ | async"
                  [quantityPicker]="quantityPicker$ | async"
                  [checkoutPageSettings]="checkoutPageSettings$ | async"
                  [extraCosts]="extraCosts$ | async">
</app-summary-page>
